export const apiConfig = {
	BACKEND_REST_URL: process.env.REACT_APP_BACKEND_BASE_URL,
	URL_IMPRESSUM: 'https://www.breuninger.com/de/service/imprint/',
	URL_DATENSCHUTZ: '/Datenschutzinformation Hinweisgeberformular.pdf'
};
